import { StringLightsIcon } from './StringLightsIcon';

/**
 * author: Michael Irigoyen
 * id 6CCDB34F-9B02-4712-B615-A7E1056B534D
 * name string-lights
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/string-lights.svg
 * tags
 * - Home Automation 
 */
export const ItalianLightsIcon = StringLightsIcon;
export default ItalianLightsIcon